// Mock data for EC Home Builds website
// This will be replaced with backend API calls later

export const floorPlans = [
  {
    id: 'harrison',
    name: 'The Harrison',
    sqft: '1,627',
    bedrooms: 3,
    bathrooms: 2,
    garage: '2-Car Garage',
    style: 'Ranch',
    description: 'The Harrison delivers beautifully efficient ranch living with an open-concept layout that maximizes every square foot. This single-level design features a private primary suite that offers a peaceful retreat from daily life, while thoughtful architecture creates timeless curb appeal.',
    features: [
      'Open kitchen with modern finishes and generous counter space',
      'Spacious walk-in closet in primary suite',
      'Covered front porch for outdoor living',
      'Efficient layout ideal for narrow or urban lots',
      'Two additional bedrooms with ample closet space',
      'Attached two-car garage with interior access'
    ],
    images: [
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/2c754e14621a4aa4a7f982ca96ed3ed3/optimized/tempImagegbm9cj.jpg',
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/35400b6b12e64cf08f2b66b3caf0450e/optimized/tempImageFVCxv7.jpg'
    ],
    thumbnail: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/2c754e14621a4aa4a7f982ca96ed3ed3/optimized/tempImagegbm9cj.jpg'
  },
  {
    id: 'oakwood',
    name: 'The Oakwood',
    sqft: '2,936',
    bedrooms: 4,
    bathrooms: 3.5,
    garage: '2-Car Garage',
    style: 'Modern Farmhouse',
    description: 'The Oakwood represents modern farmhouse living at its finest. With nearly 3,000 square feet of meticulously designed space, this home caters to families who appreciate both style and substance. The main-level owner\'s suite provides convenience and luxury, while three additional upstairs bedrooms ensure everyone has their own space.',
    features: [
      'Double gables, premium stonework, and sophisticated detailing',
      'Main-floor owner\'s suite with spa-like bathroom',
      'Dedicated library or home office space',
      'Upper-level balcony overlooking great room',
      'Expansive walk-in closet',
      'Upscale architecture with extraordinary street presence'
    ],
    images: [
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/90fe7512dd9d4297a0aa035f0019ea99/optimized/tempImageRMn3Vv.jpg',
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/0e0dbc06e1794e52814e97623a36c6af/optimized/tempImageMyQwpl.jpg',
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/095bfe094d06446591dbe7057434cdde/optimized/tempImage9LZAlt.jpg'
    ],
    thumbnail: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/90fe7512dd9d4297a0aa035f0019ea99/optimized/tempImageRMn3Vv.jpg'
  },
  {
    id: 'farmhouse',
    name: 'The Farmhouse',
    sqft: '2,420',
    bedrooms: 4,
    bathrooms: 3,
    garage: '2-Car Garage',
    style: 'Classic Farmhouse',
    description: 'The Farmhouse embodies timeless American architecture with its clean vertical siding, inviting proportions, and classic details that never go out of style. This versatile design offers flexibility where it matters most.',
    features: [
      '2,420 square feet designed for real family life',
      'Open kitchen and living areas',
      'Main level den converts to guest suite',
      'Four spacious bedrooms upstairs',
      'Optional wraparound porch',
      'Three full bathrooms'
    ],
    images: [
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/13fac9c9e904445684c93c7dfde3bc98/optimized/tempImagesgZkX4.jpg',
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/c8378cd6f0e84ab283bad46b7327b588/optimized/tempImagejCeHGJ.jpg',
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/9f4d1e5c05074dc0b714e1f4c644e707/optimized/tempImageA8ky8s.jpg'
    ],
    thumbnail: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/13fac9c9e904445684c93c7dfde3bc98/optimized/tempImagesgZkX4.jpg'
  },
  {
    id: 'shinglewood',
    name: 'The Shinglewood',
    sqft: '2,450',
    bedrooms: 4,
    bathrooms: 2.5,
    garage: '2-Car Garage',
    style: 'Transitional Craftsman',
    description: 'Where timeless Craftsman character meets contemporary livability – The Shinglewood bridges traditional charm and modern functionality. Coastal gray siding paired with crisp white trim and natural stone accents creates a look that\'s both current and enduring.',
    features: [
      'Authentic Craftsman detailing with modern updates',
      'Oversized windows for abundant natural light',
      'Main-level office with French doors',
      'Upper-level laundry room for convenience',
      'Open-concept living and dining areas',
      'Premium exterior materials and finishes'
    ],
    images: [
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/9750450d76014454920056b4ed2dd02b/optimized/tempImageZElIAU.jpg',
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/86b816b968e24b88818b3434698a4ab4/optimized/tempImageNuvjm3.jpg'
    ],
    thumbnail: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/9750450d76014454920056b4ed2dd02b/optimized/tempImageZElIAU.jpg'
  },
  {
    id: 'cedar-point',
    name: 'The Cedar Point',
    sqft: '1,864',
    bedrooms: 4,
    bathrooms: 2.5,
    garage: '2-Car Garage',
    style: 'Traditional Two-Story',
    description: 'The Cedar Point offers the perfect balance of traditional appeal and contemporary functionality. At 1,864 square feet, this home proves you don\'t need excessive space to live well. The welcoming front porch creates an instant connection with your neighborhood.',
    features: [
      'Timeless two-story architecture',
      'Efficient layout maximizing every square foot',
      'Urban infill ready design',
      'Welcoming front porch',
      'Open main-level layout',
      'Four flexible bedrooms'
    ],
    images: [
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/5c3623eeba1c47a0b094b8cb0a576639/optimized/tempImageel835P.jpg',
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/86727da4f6284d0aaf3cd774260ed548/optimized/tempImage4hvVRA.jpg'
    ],
    thumbnail: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/5c3623eeba1c47a0b094b8cb0a576639/optimized/tempImageel835P.jpg'
  },
  {
    id: 'maplewood',
    name: 'The Maplewood',
    sqft: '1,406',
    bedrooms: 3,
    bathrooms: 2,
    garage: '2-Car Garage',
    style: 'Ranch',
    description: 'The Maplewood proves that thoughtful design matters more than square footage. This efficient ranch layout delivers everything you need for comfortable living without unnecessary excess.',
    features: [
      'Open great room design',
      'Private owner\'s suite separated from additional bedrooms',
      'Low-maintenance single-level living',
      'Walk-in closet in primary suite',
      'Efficient systems and durable materials',
      'Perfect for first-time buyers or downsizers'
    ],
    images: [
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/23ac68ea430a418cbe619a1757925f94/optimized/tempImager1IR6h.jpg',
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/5062bc0fea794288a14c859a4c6b9b16/optimized/tempImageGekR90.jpg'
    ],
    thumbnail: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/23ac68ea430a418cbe619a1757925f94/optimized/tempImager1IR6h.jpg'
  },
  {
    id: 'independence-duplex',
    name: 'The Independence Duplex',
    sqft: '1,885 per unit',
    bedrooms: 3,
    bathrooms: 2.5,
    garage: '2-Car per unit',
    style: 'Duplex Investment',
    description: 'The Independence Duplex represents a sophisticated approach to multi-family living and real estate investment. This thoughtfully designed dual-unit property offers the perfect solution for investors seeking cash flow, multi-generational families wanting proximity with privacy, or owner-occupants looking to offset their mortgage.',
    features: [
      'Strong rental demand in Central Ohio markets',
      'Live in one unit, rent the other',
      'Mirror layout simplifies construction',
      'Separate utilities and HVAC systems',
      'Professional exterior with lasting appeal',
      'Each unit: 1,885 sq. ft. of quality living space'
    ],
    images: [
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/37d56fcee08a40fcad7ceda69d2079ee/optimized/tempImageAYcKTe.jpg',
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/dac66a99f6174fd7ac9900e7e91f44bd/optimized/tempImagexkOmlY.jpg',
      'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/bbc3c1de01274061ad3d5c8ddb572469/optimized/tempImageB90ky6.jpg'
    ],
    thumbnail: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/37d56fcee08a40fcad7ceda69d2079ee/optimized/tempImageAYcKTe.jpg'
  }
];

export const testimonials = [
  {
    id: 1,
    text: "Working with EC Home Builds transformed our investment strategy. The fixed-price contract gave us confidence, and the quality exceeded our expectations. We gained significant equity at completion and have since commissioned two additional builds.",
    author: "Investment Client",
    type: "investor"
  },
  {
    id: 2,
    text: "From our first consultation to receiving the keys, Erick and his team made the building process transparent and stress-free. Our custom home on our family's lot is everything we envisioned and more. The craftsmanship is outstanding.",
    author: "Homeowner",
    type: "homeowner"
  }
];

export const portfolioImages = [
  {
    id: 1,
    url: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/90fe7512dd9d4297a0aa035f0019ea99/optimized/tempImageRMn3Vv.jpg',
    title: 'Modern Farmhouse Exterior',
    category: 'exterior'
  },
  {
    id: 2,
    url: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/0e0dbc06e1794e52814e97623a36c6af/optimized/tempImageMyQwpl.jpg',
    title: 'Luxury Interior Living Space',
    category: 'interior'
  },
  {
    id: 3,
    url: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/13fac9c9e904445684c93c7dfde3bc98/optimized/tempImagesgZkX4.jpg',
    title: 'Classic Farmhouse Design',
    category: 'exterior'
  },
  {
    id: 4,
    url: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/c8378cd6f0e84ab283bad46b7327b588/optimized/tempImagejCeHGJ.jpg',
    title: 'Open Concept Interior',
    category: 'interior'
  },
  {
    id: 5,
    url: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/9750450d76014454920056b4ed2dd02b/optimized/tempImageZElIAU.jpg',
    title: 'Craftsman Style Home',
    category: 'exterior'
  },
  {
    id: 6,
    url: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/8ez3v3g1znwt914/095bfe094d06446591dbe7057434cdde/optimized/tempImage9LZAlt.jpg',
    title: 'Modern Kitchen Design',
    category: 'interior'
  }
];

export const companyInfo = {
  name: 'EC Home Builds',
  founder: 'Erick Cordero',
  location: 'Columbus, Ohio',
  phone: '(614) 354-6441',
  email: 'erick@echomebuilds.com',
  website: 'www.echomebuilds.com',
  yearsExperience: '11+',
  logoUrl: 'https://customer-assets.emergentagent.com/job_luxury-homes-ohio/artifacts/vl8cv02j_01%20PNG%20LOGO%20GOLD.png'
};

export const buildProcess = [
  {
    step: 1,
    title: 'Lot Review & Feasibility',
    description: 'We evaluate your property, assess zoning requirements, and confirm your lot is ready for construction.'
  },
  {
    step: 2,
    title: 'Plan Selection',
    description: 'Choose your ideal floor plan from our portfolio or work with us to customize a design that fits your vision.'
  },
  {
    step: 3,
    title: 'Budget & Agreement',
    description: 'Receive a detailed, fixed-price proposal with transparent cost breakdowns and clear timelines.'
  },
  {
    step: 4,
    title: 'Permitting & Financing',
    description: 'We coordinate all permits, approvals, and work with your lender to ensure smooth financing.'
  },
  {
    step: 5,
    title: 'Construction & Quality Checks',
    description: 'Your home takes shape with regular updates, site visits, and rigorous quality inspections at every milestone.'
  },
  {
    step: 6,
    title: 'Completion & Warranty',
    description: 'Final walkthrough, keys delivered, and comprehensive warranty coverage for your peace of mind.'
  }
];
